'use client';

import { WishlistButtonWithApi } from '@packages/modules/src/WishlistButtonWithApi/WishlistButtonWithApi';
import { AddToBasketButton } from '@packages/modules/src/AddToBasketButton/AddToBasketButton.client';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { useSearchParams } from 'next/navigation';
import { ProductVariationFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductVariationFragmentFragmentDoc';
import { getGlycerinWishlistProductPayload } from '../Tracking/helper/getGlycerinWishlistProductPayload';
import { AddToBasketLayer } from '../AddToBasketLayer';

export const ProductActions = ({
  data,
  basketTrackingProps,
  className,
}: {
  data: FragmentType<typeof ProductVariationFragmentFragmentDoc>;
  basketTrackingProps?: { category: string; detail: string; label: string };
  className?: string;
}) => {
  const productVariation = getFragmentData(ProductVariationFragmentFragmentDoc, data);
  const searchParams = useSearchParams();
  const ref = searchParams?.get('ref') || null;

  return (
    <div className={`flex gap-1 ${className ?? ''}`}>
      <WishlistButtonWithApi
        trackingProps={{
          products: [
            getGlycerinWishlistProductPayload({
              data: productVariation,
              refSearchParam: ref,
            }),
          ],
        }}
        sku={productVariation.sku}
        productName={productVariation.name}
        variant="contained"
        sx={{ flexShrink: 0 }}
        availability={productVariation.availability.state}
      />
      <AddToBasketButton
        data={productVariation}
        sx={{ fontSize: '1rem' }}
        clickTrackingProps={basketTrackingProps}
      >
        {(layerData, lineItem) => <AddToBasketLayer data={layerData} lineItem={lineItem} />}
      </AddToBasketButton>
    </div>
  );
};
